<template>
  <div class="task_manage">
    <div class="title" @click="handleQuarterShow">
      <span class="tit_message">{{formatFormData.quarterName}}</span>
      <span class="img_box">
        <img src="@/assets/appraise/ic_jiantou_down  2@2x.png" alt />
      </span>
    </div>
    <div class="content">
      <!-- <div class="cont_item">
        <div class="item_left">
          <p class="title">本季度填报功能</p>
          <p class="desc">开启后州市、省级工作人员能填报相关数据</p>
        </div>
        <div v-if="selectFrom.apply === 'on' || showDialog" class="item_right">
          <p class="switch">
            <van-switch
              v-model="selectFrom.apply"
              @change="changeTab"
              active-color="#fff"
              inactive-color="#fff"
              active-value="on"
              inactive-value="off"
            />
          </p>
          <p class="status">已开启</p>
        </div>
        <div v-else class="item_right_close">
          <p>已关闭</p>
        </div>
      </div> -->
      <div class="cont_item">
        <div class="item_left">
          <p class="title">本季度审核功能</p>
          <p class="desc">开启后省级工作人员能审核相关数据</p>
        </div>
        <div v-if="selectFrom.audit === 'on' || showDialog1" class="item_right">
          <p class="switch">
            <van-switch
              v-model="selectFrom.audit"
              @change="changeTab1"
              active-color="#fff"
              inactive-color="#fff"
              active-value="on"
              inactive-value="off"
            />
          </p>
          <p class="status">已开启</p>
        </div>
        <div v-else class="item_right_close">
          <p>已关闭</p>
        </div>
      </div>
    </div>
    <common-picker
      ref="commonPickerQuarter1"
      :typeList="quarterList"
      :cols="1"
      @getTypeValue="handleQuarterValue"
    ></common-picker>
    <confirmDialog
      v-if="showDialog"
      :title="'提示'"
      :content="'关闭该功能后将不能再次开启，是否确定关闭？'"
      :cancelTxt="'取消'"
      :confirmTxt="'关闭'"
      @confirm="confirm"
      @cancel="cancel"
    ></confirmDialog>
    <confirmDialog
      v-if="showDialog1"
      :title="'提示'"
      :content="'关闭该功能后将不能再次开启，是否确定关闭？'"
      :cancelTxt="'取消'"
      :confirmTxt="'关闭'"
      @confirm="confirm1"
      @cancel="cancel1"
    ></confirmDialog>
  </div>
</template>

<script>
import confirmDialog from "../components/confirmDialog.vue";
import commonAPI from "../../../utils/common";
import api from '../../../service/modules/appraiseNew.js';
import commonPicker from "../../../components/base/commonPicker.vue";
export default {
  components: {
    confirmDialog,
    commonPicker
  },
  created(){
    const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
    const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU03"); //
  },
  data() {
    return {
      showDialog: false,
      showDialog1: false,
      quarterList: [], // 季度列表
      selectFrom: { // 开关选中状态
        audit: 'on',
        apply: 'on',
      },
      formData: {
        quarterName: '', // 季度名称
        quarterValue: '',
      },
    };
  },
  computed: {
    formatFormData() { // 格式化查询条件
      if (!this.formData.quarterValue) {
        const currentData = new Date();
        const currentYear = currentData.getFullYear();
        const currentMonth = currentData.getMonth();
        const currentQuarter = Math.floor(currentMonth / 3) + 1;
        const arr1 = new Array('一', '二', '三', '四');
        return {
          year: currentYear,
          quarter: currentQuarter,
          quarterName: `${currentYear}年第${arr1[currentQuarter - 1]}季度`
        }
      }
      const arr2 = this.formData.quarterValue.split('-');
      return {
        year: arr2[0],
        quarter: arr2[1],
        quarterName: this.formData.quarterName
      }
    },
    // 传给后端的数据 需要去除无用的参数，狗日的，多个参数都不行
    formatFormDataCopy() {
      const data = JSON.parse(JSON.stringify(this.formatFormData));
      delete data.quarterName;
      return data;
    },
  },
  async created() {
    // 初始化季度列表
    const defaultSelect = await this.initQuarterList();
    // 初始化季度选择器的值
    this.formData.quarterName = Object.values(defaultSelect)[0];
    this.formData.quarterValue = Object.keys(defaultSelect)[0];
    // 初始化选中状态
    this.initSwitchStatus();
  },
  methods: {
    // 初始化季度列表
    initQuarterList() {
      return new Promise((resolve, reject) => {
        api.getQuarters().then(res => {
          if (!res.data.length) reject('无季度数据');
          const quarterList = res.data.map(item => {
            const keys = Object.keys(item)
            return {
              code: keys[0],
              text: item[keys[0]],
            }
          })
          this.quarterList = [quarterList.reverse()];
          resolve(res.data[res.data.length - 1])
        }).catch(e => {
          reject(e);
        })
      })
    },
    // 初始化选中状态
    initSwitchStatus() {
      return new Promise((resolve, reject) => {
        api.switchStatus(this.formatFormDataCopy).then(res => {
          res.data.forEach(item => {
            this.selectFrom[item.code] = item.value;
          })
          resolve()
        }).catch(e => {
          reject(e);
        })
      })
    },
    // 设置年份季度
    handleQuarterValue(value) {
      this.formData.quarterName = value[0].text;
      this.formData.quarterValue = value[0].code;
      this.initSwitchStatus();
    },
    // 切换开关
    changeTab() {
      this.showDialog = true;
    },
    confirm() {
      api.turnOffApply(this.formatFormDataCopy);
      this.showDialog = false;
    },
    cancel() {
      this.selectFrom.apply = 'on';
      this.showDialog = false;
    },
    // 切换开关
    changeTab1() {
      this.showDialog1 = true;
    },
    confirm1() {
      api.turnOffAudit(this.formatFormDataCopy);
      this.showDialog1 = false;
    },
    cancel1() {
      this.selectFrom.audit = 'on';
      this.showDialog1 = false;
    },
    // 展示季度选择器
    handleQuarterShow() {
      this.$refs.commonPickerQuarter1 && this.$refs.commonPickerQuarter1.showPicker();
    },
  }
};
</script>

<style scoped lang="less">
.task_manage {
  padding: 0 12px;
  // background-color: #fbfbfb;
  & > .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0 12px;
  }
  .tit_message {
    display: inline-block;
    width: 148px;
    font-size: 20px;
    color: #333;
    font-weight: 500;
  }
  .img_box {
    display: inline-block;
    width: 200px;
  }
  img {
    display: inline-block;
    width: 6px;
    height: 4px;
    vertical-align: middle;
  }
  .content .cont_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 0 16px;
    width: 351px;
    height: 79px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    .item_left {
      padding: 21px 0 20px;
      .title {
        margin-bottom: 12px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
      .desc {
        font-size: 12px;
        color: #666;
      }
    }
    .item_right {
      margin: 16px 0 4px;
      width: 40px;
      .switch {
        margin-bottom: 7px;
        /deep/ .van-switch {
          margin-left: 0;
          width: 40px;
          height: 24px;
        }
        /deep/ .van-switch__node {
          margin-top: 1px;
          width: 22px;
          height: 22px;
        }
      }
      .status {
        font-size: 12px;
        color: #999;
      }
    }
  }
  .item_right_close {
    font-size: 12px;
    color: #999;
    line-height: 79px;
  }
  /deep/ .van-switch__node {
    box-shadow: none;
  }
}
</style>